export const DEFAULT_MAX_NATIVE_CLASSIFIED_PHOTOS = 60
export const DEFAULT_MAX_PANORAMIC_CLASSIFIED_PHOTOS = 40
